import PropTypes from 'prop-types'
import styled from 'styled-components'

import colors from 'components/utils/colors'

import FilterSectionBool from './FilterSectionBool'
import FilterSectionText from './FilterSectionText'
import FilterSectionSelect from './FilterSectionSelect'
import FilterSectionMultiSelect from './FilterSectionMultiSelect'
import FilterSectionDate from './FilterSectionDate'
import FilterSectionStatuses from './FilterSectionStatuses'

const StyledFilterList = styled.div`
  background-color: ${colors.secondary98};
`

const FilterList = ({
  activeFilters, onFilterChange,
  filterSectionsDesc, filterSectionsNamesMap, userTimeZone,
}) => {
  const onFilterChange_ = (filterData) => {
    onFilterChange(filterData)
  }

  const getValue = (filterDesc) => {
    let value = activeFilters[filterDesc.name]
    if (filterDesc.type === 'bool') {
      value = !!value
    } else if (filterDesc.type === 'multiselect' || filterDesc.type === 'statuses') {
      value = value || []
    }
    return value
  }

  return (
    <StyledFilterList data-test='filter-list'>
      {filterSectionsDesc.map(filterDesc => {
        const FilterSection = ({
          'bool': FilterSectionBool,
          'text': FilterSectionText,
          'textarea': FilterSectionText,
          'select': FilterSectionSelect,
          'multiselect': FilterSectionMultiSelect,
          'date': FilterSectionDate,
          'statuses': FilterSectionStatuses,
        })[filterDesc.type]
        const value = getValue(filterDesc)
        const hasOptions = ['select', 'multiselect', 'statuses'].includes(filterDesc.type)

        return (
          <FilterSection
            key={filterDesc.name + (value ? '' : '_empty')}
            multiline={filterDesc.type === 'textarea'}
            title={filterDesc.title || filterSectionsNamesMap[filterDesc.name]}
            name={filterDesc.name}
            value={value}
            onChange={onFilterChange_}
            options={hasOptions ? filterDesc.options : null}
            iconComponentsMap={hasOptions ? filterDesc.iconComponentsMap : null}
            userTimeZone={userTimeZone}
            disabled={filterDesc.disabled}
          />
        )
      })}
    </StyledFilterList>
  )
}

FilterList.propTypes = {
  activeFilters: PropTypes.object.isRequired,
  onFilterChange: PropTypes.func.isRequired,
  filterSectionsDesc: PropTypes.array.isRequired,
  filterSectionsNamesMap: PropTypes.object,
  userTimeZone: PropTypes.string,
}

export default FilterList
